import { makeEnvironmentProviders } from "@angular/core";
import { CourseService } from "app/@core/services/course.service";
import { UserService } from "app/@core/services/users.service";
// ... import other services

export function provideDataServices() {
  return makeEnvironmentProviders([
    // Senior Choice: Provide concrete services directly.
    // If you need a Mock, use a global 'environment' check here.
    { provide: CourseService, useClass: CourseService },
    { provide: UserService, useClass: UserService },
  ]);
}
